import "./SideBar.scss";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RoutePaths } from "src/resources/enum";
import GridViewIcon from "@mui/icons-material/GridView";
import ScreenShareIcon from "@mui/icons-material/ScreenShare";
import EngineeringIcon from "@mui/icons-material/Engineering";
import BuildIcon from "@mui/icons-material/Build";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import FeedIcon from "@mui/icons-material/Feed";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import DomainOutlinedIcon from "@mui/icons-material/DomainOutlined";

import { ReactComponent as SendRequestToBMCIcon } from "src/assets/icons/sendRequestToBMCIcon.svg";
import { ReactComponent as ListSubsetIndicatorIcon } from "src/assets/icons/list-subset-indicator.svg";
import { isCivilDefenseUser } from "src/utils/helpers";

export default function SideBar() {
  const location = useLocation();
  const { pathname } = location;
  const { t } = useTranslation(["registration", "common"]);
  const customFont = () => {
    return isCivilDefenseUser() ? "font-weight-700" : "";
  };
  return (
    <div className="sidebar">
      <div className="sidebar__container">
        {/* <Tree /> */}
        <div
          className={`sidebar__container__item  mb-2  ${
            pathname === RoutePaths.Dashboard ? "active" : ""
          }`}
        >
          <Link
            to={RoutePaths.Dashboard}
            className="sidebar__container__item-link"
          >
            <span className="icon-bg">
              <GridViewIcon />
            </span>
            <span className={`${customFont()}`}>
              {isCivilDefenseUser() ? t("cdDashboard") : t("dashboard")}
            </span>
          </Link>
        </div>
        {!isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.ATECases) ? "active" : ""
            }`}
          >
            <Link
              to={RoutePaths.ATECases}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <ScreenShareIcon />
              </span>
              <span>{t("ateCases")}</span>
            </Link>
          </div>
        )}

        {isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.AllCases) ? "active" : ""
            }`}
          >
            <Link
              to={RoutePaths.AllCases}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <ScreenShareIcon />
              </span>
              <span className="font-weight-700">{t("maintenanceFaults")}</span>
            </Link>
          </div>
        )}

        {isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.BreachedCases) ? "active" : ""
            }`}
          >
            <Link
              to={RoutePaths.BreachedCases}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <ListSubsetIndicatorIcon className="subset-icon" />
              </span>
              <span>{t("breachedMaintenanceFaults")}</span>
            </Link>
          </div>
        )}
        {!isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.MaintenanceRequests) ? "active" : ""
            }`}
          >
            <Link
              to={RoutePaths.MaintenanceRequests}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <EngineeringIcon />
              </span>
              <span>{t("maintenanceRequests")}</span>
            </Link>
          </div>
        )}
        <div
          className={`sidebar__container__item  mb-2  ${
            pathname.includes(RoutePaths.PreventiveAppointment) ? "active" : ""
          }`}
        >
          <Link
            to={RoutePaths.PreventiveAppointment}
            className="sidebar__container__item-link"
          >
            <span className="icon-bg">
              <BuildIcon />
            </span>
            <span className={`${customFont()}`}>
              {t("preventiveAppointments")}
            </span>
          </Link>
        </div>

        {isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.BreachedPreventiveAppointments)
                ? "active"
                : ""
            }`}
          >
            <Link
              to={RoutePaths.BreachedPreventiveAppointments}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <ListSubsetIndicatorIcon className="subset-icon" />
              </span>
              <span>{t("breachedPreventiveAppointments")}</span>
            </Link>
          </div>
        )}

        {!isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.AssignedBuildings) ? "active" : ""
            }`}
          >
            <Link
              to={RoutePaths.AssignedBuildings}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <HomeWorkIcon />
              </span>

              <span>{t("assignedBuildings")}</span>
            </Link>
          </div>
        )}
        {!isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.ViewInvoices) ? "active" : ""
            }`}
          >
            <Link
              to={RoutePaths.ViewInvoices}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <FeedIcon />
              </span>

              <span>{t("viewInvoices")}</span>
            </Link>
          </div>
        )}

        {isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.BMCWithRating) ? "active" : ""
            }`}
          >
            <Link
              to={RoutePaths.BMCWithRating}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <DomainOutlinedIcon />
              </span>

              <span className="font-weight-700">{t("bmcWithRating")}</span>
            </Link>
          </div>
        )}

        {isCivilDefenseUser() && (
          <div
            className={`sidebar__container__item  mb-2  ${
              pathname.includes(RoutePaths.SendRequestToBMC) ? "active" : ""
            }`}
          >
            <Link
              to={RoutePaths.SendRequestToBMC}
              className="sidebar__container__item-link"
            >
              <span className="icon-bg">
                <NoteAltOutlinedIcon />
              </span>

              <span className="font-weight-700">{t("sendRequestToBMC")}</span>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
